<template>
  <div class="dial-table-container">
    <div class="left-table" v-if="dialInfo.messages">
      <div class="left-table-container">
        <div class="row" v-for="(row, index) in dialInfo.messages" :key="`row-${index}`">
          <div class="data" v-if="row.messageIcon">{{ row.messageIcon }}</div>
          <div class="data" v-if="row.message" v-html="row.message">{{ row.message }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ST',
  components: {},
  props: {
    dialInfo: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.dial-table-container {
  margin-top: 0px;
  display: flex;
  .left-table {
    display: flex;
    margin-right: 40px;
    flex-direction: column;
    text-align: left;
    margin-top: 0px;
    .left-table-container {
      display: flex;
      flex-direction: column;
      .row {
        display: flex;
        margin: 0 10px;
        flex-direction: row;
        .header {
          background-color: #898c8d;
          color: white;
          padding: 10px 12px;
          font-size: 14px;
        }
        .data {
          color: #1d1d1b;
          font-size: 14px;
          margin-top: 10px;
          text-align: left;
        }
        .data:nth-child(odd) {
          background: #ffffff;
        }
      }
    }
  }
  .right-table {
    display: flex;
    flex-direction: column;
    .table-header {
      color: #ffffff;
      background-color: #898c8d99;
      padding: 5px 0;
      height: 20px;
    }
    .right-table-container {
      display: flex;
      .row {
        display: flex;
        flex-direction: column;
        .header {
          background-color: #898c8d;
          color: white;
          padding: 10px 12px;
          font-size: 14px;
        }
        .data {
          color: #1d1d1b;
          font-size: 14px;
          margin-top: 10px;
          height: 16px;
        }
      }
    }
  }
}
</style>
